import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import type { IConsentOverviewProps } from './consent-overview';

const ConsentOverview = lazy(async () => import('./consent-overview'));

const el = '.fa-component--consent-overview';
const DOM = document.querySelectorAll(el);
const token: HTMLInputElement = document.querySelector('input[name="__RequestVerificationToken"]')!;

const render = function () {
    if (DOM) {
        DOM.forEach((component) => {
            const props = JSON.parse(component.getAttribute('data-props')!) as IConsentOverviewProps;

            createRoot(component).render(<ConsentOverview {...props} antiForgeryToken={token.value} />);
        });
    }
};

export default {
    render,
};
